const Login = () => {
    return (
        <li>
            <a href="/login">Log in</a>
        </li>
    );
};

export default Login;
